export const addToDatalayer = data => {
    if (!data || !data.event) return;
    const {dataLayer} = window;
    if (!dataLayer) return;
    dataLayer.push(data);
};
